import { render, staticRenderFns } from "./TaskBoardNotificationDropdown.vue?vue&type=template&id=44184f0e"
import script from "./TaskBoardNotificationDropdown.vue?vue&type=script&lang=js"
export * from "./TaskBoardNotificationDropdown.vue?vue&type=script&lang=js"
import style0 from "./TaskBoardNotificationDropdown.vue?vue&type=style&index=0&id=44184f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports